import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { useDemo } from '../../contexts/DemoContext';
// useSimpleAccess removed - mode selection no longer used
import { useUserData } from '../../hooks/useUserData';
import { useSidebar } from '../../contexts/SidebarContext';
import { Outlet, Link, useLocation } from 'react-router-dom';
import OnboardingModal from '../onboarding/OnboardingModal';
// VerticalTabBar removed - mode selection no longer used
import Sidebar from '../ui/Sidebar';
import Header from '../ui/Header';
import DemoModeBanner from '../demo/DemoModeBanner';
// SwitchToPrecisionBanner removed - mode selection no longer used

const AppLayoutWithTabs = () => {
  const { user, loading, showOnboarding, saveOnboardingData, setShowOnboarding, initialSetupStatus } = useAuth();
  const { isPaid } = useSubscription();
  const { isDemoModeActive } = useDemo();
  // useSimpleAccess removed - mode selection no longer used
  const accessLoading = false;
  const { userData, loading: userDataLoading } = useUserData();
  const { sidebarExpanded, toggleSidebar } = useSidebar();
  const location = useLocation();
  
  // Show sidebar (always precision mode)
  const showSidebar = true;

  // Tab bar removed - mode selection no longer used
  const showTabBar = false;

  if (loading || accessLoading || userDataLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Tab bar removed - mode selection no longer used */}

      {/* Main Content Area */}
      <div className="flex min-h-screen">
        {/* Sidebar - Always precision mode */}
        {user && showSidebar && (
          <Sidebar viewMode="detailed" showTabBar={showTabBar} />
        )}

        {/* Main Content */}
        <main className="flex-1">
          {/* Header */}
          {user && (
            <Header showTabBar={showTabBar} />
          )}
          
          {/* Demo Banner - shown when demo mode is ON, positioned below header (header is h-16 = 64px) */}
          {isDemoModeActive && (
            <div className="sticky top-16 left-0 right-0 z-50">
              <DemoModeBanner />
            </div>
          )}
          
          {/* Free Plan / Upgrade banner - free is forever, projections masked beyond 5 years */}
          {!isDemoModeActive && !isPaid && (
            <div className="sticky top-16 left-0 right-0 z-50 border-y border-amber-200 bg-amber-50/90 backdrop-blur">
              <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 text-sm text-amber-900">
                <p className="m-0 font-semibold flex flex-wrap gap-1">
                  <span>You are on the Free Plan —</span>
                  <Link
                    to="/upgrade"
                    className="font-semibold text-amber-900 underline underline-offset-4 hover:text-amber-950 whitespace-nowrap"
                  >
                    Upgrade to unlock full projections and all features
                  </Link>
                </p>
              </div>
            </div>
          )}

          {/* Page Content */}
          <div className={`${user ? 'pb-16 lg:pb-0' : ''}`}>
            <Outlet />
          </div>
        </main>
      </div>

      {/* Onboarding Modal */}
      <OnboardingModal
        isOpen={showOnboarding}
        onComplete={saveOnboardingData}
        onSkip={() => setShowOnboarding(false)}
      />
    </div>
  );
};

export default AppLayoutWithTabs;

